import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaUltimoSimulacro(props) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [postNombre, setPostNombre] = useState("");
  const [postFecha, setPostFecha] = useState("");
  const [postRecomendacion, setPostRecomendacion] = useState("");
  const [postSeguimiento, setPostSeguimiento] = useState("");

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaUltimoSimulacro",
      data: {
        nombre: postNombre,
        fechaSimulacro: postFecha,
        recomendaciones: postRecomendacion,
        seguimientoRecomendaciones: postSeguimiento,
        solicitudId: props.idSolicitud,
      },
    })
      .then(() => {
        alert("Último simulacro creado con éxito");

        props.onCreate(); // 🔁 refresca tabla

        // limpiar formulario
        setPostNombre("");
        setPostFecha("");
        setPostRecomendacion("");
        setPostSeguimiento("");

        setIsOpen(false);
      })
      .catch(() => alert("Error al crear último simulacro"));
  };

  return (
    <>
      <button className="btn btn-primary mb-3" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              Crear Último Simulacro
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <div className="form-group">
                <label>Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  value={postNombre}
                  onChange={(e) => setPostNombre(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Fecha simulacro</label>
                <input
                  type="date"
                  className="form-control"
                  value={postFecha}
                  onChange={(e) => setPostFecha(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Recomendaciones</label>
                <textarea
                  className="form-control"
                  value={postRecomendacion}
                  onChange={(e) => setPostRecomendacion(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Seguimiento recomendaciones</label>
                <textarea
                  className="form-control"
                  value={postSeguimiento}
                  onChange={(e) => setPostSeguimiento(e.target.value)}
                  required
                />
              </div>

              <div className="text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => setIsOpen(false)}
                >
                  Cancelar
                </button>

                <button type="submit" className="btn btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaUltimoSimulacro;
